import { TabItem } from '../../../commonComponents/TabItem';

import '../../../../themes/Button.scss';
import { getShouldEnablePermanentJobV2 } from '../../../../posthog';

export const DNTTabs = ({ value, onValueChanged }) => {
  const tabs = [
    {
      default: true,
      label: 'Account Info',
      value: 'general',
    },
    {
      label: 'Worker Type',
      value: 'workerClassification',
    },
    {
      label: 'Child Offices',
      value: 'childOffices',
    },
    {
      label: 'Payment',
      value: '#',
      linkedItems: [
        {
          label: 'Payment Methods',
          value: 'payment',
        },
        {
          label: 'Invoices',
          value: 'invoices',
        },
        {
          label: 'Receipts',
          value: 'officeReciptsTab',
        },
      ],
    },
    {
      label: 'Jobs',
      value: '#',
      linkedItems: [
        {
          label: 'Temp Requests',
          value: 'jobs',
        },
        {
          label: `Permanent Hires${getShouldEnablePermanentJobV2() ? ' (Old)' : ''}`,
          value: 'ppJobs',
        },
        ...[
          getShouldEnablePermanentJobV2()
            ? {
                label: 'Permanent Jobs',
                value: 'permanent-jobs',
              }
            : null,
        ].filter(Boolean),
      ],
    },
    {
      label: 'Professionals',
      value: '#',
      linkedItems: [
        {
          label: 'Map',
          value: 'mapTab',
        },
        {
          label: 'Favorites',
          value: 'favorites',
        },
        {
          label: 'Highly-Rated',
          value: 'highlyRated',
        },
        {
          label: 'Availability',
          value: 'availability',
        },
        {
          label: 'Blocked',
          value: 'blocked',
        },
      ],
    },
    {
      label: 'Notifications',
      value: 'notifications',
    },
    {
      label: 'Feedback',
      value: '#',
      linkedItems: [
        {
          label: 'Reviews',
          value: 'reviewTab',
        },
        {
          label: 'GoTu Feedback',
          value: 'gotu-feedback',
        },
        {
          label: 'NPS',
          value: 'nps',
        },
      ],
    },
    {
      label: 'Edits',
      value: 'edits',
    },
    {
      label: 'Notes',
      value: 'notes',
    },
    {
      // GOTU-6663: Promotions became a group once the office gained a second
      // promotion surface. The Best in Dental item keeps the `promotions`
      // segment so existing links to that tab still land on it.
      label: 'Promotions',
      value: '#',
      linkedItems: [
        {
          label: 'Best in Dental',
          value: 'promotions',
        },
        {
          label: 'Discounts & Promo Codes',
          value: 'promo-codes',
        },
      ],
    },
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        // Wraps rather than running off the edge: HYG carries 17 top-level
        // tabs (18 with the permanent-job-v2 flag on), which no single row
        // fits. `gap` already spaces the wrapped rows, and centring keeps a
        // short trailing row balanced instead of stranded on the left.
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '0.5rem',
        marginBottom: '4px',
        marginTop: '10px',
        position: 'relative',
      }}
    >
      {tabs.map((tab, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <TabItem
          // eslint-disable-next-line react/no-array-index-key
          key={`${tab.value}-${i}`}
          tab={tab}
          value={value}
          onValueChanged={onValueChanged}
        />
      ))}
    </div>
  );
};
